export const trainKinds = [
  { id: 1, name: '普通', htmlClassName: 'local', trainsIconText: '普' },
  { id: 2, name: '区間快速Ａ', htmlClassName: 'com_r', trainsIconText: '区' },
  { id: 3, name: '区間快速Ｂ', htmlClassName: 'com_r', trainsIconText: '区' },
  { id: 4, name: '快速Ｂ', htmlClassName: 'rapid', trainsIconText: '快' },
  { id: 5, name: '快速Ａ', htmlClassName: 'rapid', trainsIconText: '快' },
  { id: 6, name: '新快速', htmlClassName: '', trainsIconText: '' },
  { id: 7, name: '特別快速Ｂ', htmlClassName: '', trainsIconText: '' },
  { id: 8, name: '特別快速Ａ', htmlClassName: '', trainsIconText: '' },
  { id: 9, name: '団体', htmlClassName: '', trainsIconText: '' },
  { id: 10, name: '回送１', htmlClassName: '', trainsIconText: '' },
  { id: 11, name: '回送２', htmlClassName: '', trainsIconText: '' },
  { id: 12, name: '試運転', htmlClassName: '', trainsIconText: '' },
  { id: 13, name: '通勤快速Ａ', htmlClassName: 'semi_r', trainsIconText: '通' },
  { id: 14, name: '通勤快速Ｂ', htmlClassName: 'semi_r', trainsIconText: '通' },
  { id: 15, name: '通勤快速Ｃ', htmlClassName: 'semi_r', trainsIconText: '通' },
];

export function trainKindClass(id) {
  const trainKind = trainKinds.find(kind => kind.id === id);
  if (trainKind === undefined) {
    return '';
  }

  return trainKind.htmlClassName;
}

export function trainKindTrainsIconText(id) {
  const trainKind = trainKinds.find(kind => kind.id === id);
  if (trainKind === undefined) {
    return '';
  }

  return trainKind.trainsIconText;
}
